"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/Feedback/withFeedbackController.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');




var _useClassState = require('web/screens/VideoCall/useClassState');

// The same list for every instance (it was an instance field with a constant
// value; nothing mutates it).
const lowRatingReasons = [
  { value: "bad_video", label: "Video quality was bad" },
  { value: "bad_audio", label: "Audio quality was bad" },
  { value: "no_video", label: "There was no video" },
  { value: "no_audio", label: "I couldn't hear others" },
  { value: "no_my_audio", label: "Others couldn't hear me" },
  { value: "other", label: "Other issue", isExplanationNeeded: true },
]




















const withFeedbackController = (Component) => {
  

  // Was a class inside connect(): memo keeps connect's props bail-out. The
  // handlers keep stable identities (the wrapped Feedback is memoised) and
  // read the committed state and store values through `latest`, as the class
  // read `this.state`/`this.props` when called.
  const FeedbackController = (props) => {
    // One selector per field, as connect() compared mapState's fields: a change
    // elsewhere on the room user does not re-render.
    const RoomKey = _hooks.useAppSelector.call(void 0, s => (_videoRoom.selectCurrentVideoRoomUser.call(void 0, s) || {}).RoomKey)
    const RoomUserKey = _hooks.useAppSelector.call(void 0, s => (_videoRoom.selectCurrentVideoRoomUser.call(void 0, s) || {}).RoomUserKey)
    const sessionDuration = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomSessionDuration)

    const [state, setState, flushCallbacks] = _useClassState.useClassState({
      isRatingSubmitted: false,
      isSubmittedRatingLow: false,
      submittedRating: 0,
    })

    const latest = _react.useRef.call(void 0, { state, RoomKey, RoomUserKey })
    _react.useLayoutEffect.call(void 0, () => {
      latest.current = { state, RoomKey, RoomUserKey }
      flushCallbacks()
    })

    const handleFeedbackSubmit = _react.useCallback.call(void 0, ({ rating, reason, comment }) => {
      const { RoomKey: roomKey, RoomUserKey: roomUserKey } = latest.current

      _actions2.default.videoRoomRate({
        RoomKey: roomKey,
        RoomUserKey: roomUserKey,
        StarRating: rating,
        // SAFETY: a skipped reason or comment is null and is sent as null, as
        // before.
        StarRatingCode: reason ,
        // SAFETY: as above.
        StarRatingDescription: comment ,
      })
    }, [])

    const submitRating = _react.useCallback.call(void 0, (rating) => new Promise((resolve, reject) => {
      if (latest.current.state.isRatingSubmitted) return resolve()
      const isSubmittedRatingLow = rating <= 3

      setState({
        isRatingSubmitted: true,
        submittedRating: rating,
        isSubmittedRatingLow,
      })

      if (!isSubmittedRatingLow) {
        handleFeedbackSubmit({ rating })
        return resolve()
      }

      return reject()
    }), [setState, handleFeedbackSubmit])

    const submitWithRating = _react.useCallback.call(void 0, (extra) =>
      handleFeedbackSubmit({ ...extra, rating: latest.current.state.submittedRating }), [handleFeedbackSubmit])

    const submitLowRatingReason = _react.useCallback.call(void 0, (reason) =>
      submitWithRating({ reason }), [submitWithRating])
    const submitLowRatingComment = _react.useCallback.call(void 0, (comment) =>
      submitWithRating({ comment }), [submitWithRating])

    const { isRatingSubmitted, isSubmittedRatingLow } = state
    const storeProps = { RoomKey, RoomUserKey }
    // SAFETY: OwnProps plus the controller props is P; TypeScript cannot
    // prove that for a generic Omit.
    const componentProps = {
      ...props,
      ...storeProps,
      sessionDuration,
      submitRating,
      isRatingSubmitted,
      isSubmittedRatingLow,
      lowRatingReasons,
      submitLowRatingReason,
      submitLowRatingComment,
    } 

    return _react2.default.createElement(Component, { ...componentProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
  }

  return _react.memo.call(void 0, FeedbackController)
}

exports. default = withFeedbackController
